import { useIonRouter, useIonViewWillEnter, IonIcon, IonChip, IonRefresher, IonRefresherContent, IonCardContent, IonText, IonGrid, IonRow, IonCol, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";

import './Main.css'; 
import { LANGUAGE, GetStr } from "../language/Language";
import { Storage } from '@capacitor/storage';   
import NServer, { UIElement } from "../components/NServer";
import NumInputCtrl from "../components/NumInputCtrl";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

const NtkBuy : React.FC = () => {
    
    const [usd, setUSD] = useState("");
    const [nToken, setNToken] = useState("");
    const [totalUSD, setTotalUSD] = useState("");
    const [ntkExchange, setNTKExchange] = useState("");
    const [amount, setAmount] = useState("0");

    //	Initializing our router
	const router = useIonRouter();

    const numberWithCommas = (x : string) => {
        return x.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    useIonViewWillEnter(() => {
        Refresh();
    });

    const Refresh = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

		var server = new NServer();
        await server.getList("nc_buyntk", state);

        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            return;
        }
        
        setUSD(server.data.usd);
        setTotalUSD(server.data.usd);
        setNTKExchange(server.data.ntk_exchange);
        setAmount("0");
        setNToken(server.data.ntoken);
    };

    const doRefresh = async (ev : any) => {
        await Refresh();
        ev.detail.complete();
    }

    const exchangeRate = (token : string) => {
        router.push("/exchangerate/" + token, "forward", "push");
    }

    const useMax = () => {
        let pExchange = parseFloat(ntkExchange);
        if (pExchange <= 0 || isNaN(pExchange))
            return;
        let pUsd = parseFloat(totalUSD);
        if (pUsd < 0 || isNaN(pUsd))
            return;

        let amt = Math.floor(pUsd / pExchange);
        let pUsdLeft = pUsd - (amt * pExchange);
        if (amt < 1)
            amt = 0;
        if (pUsdLeft < 0.01)
            pUsdLeft = 0.0;

        setUSD("" + pUsdLeft.toFixed(2));
        setAmount("" + amt.toFixed(0));
    }

    const changeAmount = (amt : string) => {
        let pAmount = parseInt(amt);
        if (pAmount < 0 || isNaN(pAmount))
            return;
        let pExchange = parseFloat(ntkExchange);
        if (pExchange <= 0 || isNaN(pExchange))
            return;
        let pUsd = parseFloat(totalUSD);
        if (pUsd < 0 || isNaN(pUsd))
            return;

        let pUsdLeft = pUsd - (pAmount * pExchange);
        
        setUSD("" + pUsdLeft.toFixed(2));
        setAmount("" + pAmount.toFixed(0));
    }

    // do the exchange
    const exchange = async () => {
        if (negative())
        {
            showAlert(GetStr(LANGUAGE.TXT_NOT_ENOUGH_NTK));
            return;
        }

        router.push("/ntk_buy_confirm/" + amount, "forward", "push");
    }

    const onRate = () => {
        router.push("/xrate", "forward", "push");
    }

    // calculate the negative of ntoken
    const negative = () : boolean => {
        let pUsd = parseFloat(usd);
        if (pUsd < 0 || isNaN(pUsd))
            return true;
        if (pUsd < 0)
            return true;
        // else
        return false;
    }

    return (
        <IonPage>
            <IonContent>
                <div id="border-bk" />
                <IonRefresher  slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/token/wallet" ></IonBackButton>
                    </IonButtons>
                </IonToolbar>
                <IonGrid className="ion-no-padding main-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="10" size-lg="8" size-xl="6" size="12">
                            <IonCard className="flat-card">
                                <IonCardContent>
                                    <IonText><b>{ GetStr(LANGUAGE.TXT_AVAIL_USD) }</b></IonText>
                                    <p className="ion-text-center">
                                        <IonText className="balance-text" color={ negative() ? "danger" : "primary" }>$ { numberWithCommas(usd) }</IonText>
                                    </p>
                                    <IonItem lines="none">
                                        <IonLabel>{ GetStr(LANGUAGE.TXT_NTOKEN_EXCHANGE_RATE) }<b>{ ntkExchange }</b></IonLabel>
                                        <IonChip slot="end" onClick={ onRate }>{ GetStr(LANGUAGE.TXT_VIEW) }</IonChip>
                                    </IonItem>
                                </IonCardContent>
                            </IonCard>
                            <NumInputCtrl 
                                amount = { amount }
                                caption={ GetStr(LANGUAGE.TXT_NTK_EXCHANGE_CAP) } 
                                button={ GetStr(LANGUAGE.TXT_NTK_EXCHANGE_BUT) } 
                                onChange={ changeAmount } 
                                onSubmit={ exchange } 
                                deci={false}
                            />
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );

};

export default NtkBuy;